export var hexToRgb = function hexToRgb(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: Number.parseInt(result[1], 16),
        g: Number.parseInt(result[2], 16),
        b: Number.parseInt(result[3], 16)
    } : {
        r: 0,
        g: 0,
        b: 0
    };
};
export var rgbToHex = function rgbToHex(r, g, b) {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};
export var rgbToHsv = function rgbToHsv(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var diff = max - min;
    var h = 0;
    var s = max === 0 ? 0 : diff / max * 100;
    var v = max * 100;
    if (diff !== 0) {
        switch (max) {
            case r:
                h = ((g - b) / diff + (g < b ? 6 : 0)) * 60;
                break;
            case g:
                h = ((b - r) / diff + 2) * 60;
                break;
            case b:
                h = ((r - g) / diff + 4) * 60;
                break;
        }
    }
    return {
        h: Math.round(h),
        s: Math.round(s),
        v: Math.round(v)
    };
};
export var hsvToRgb = function hsvToRgb(h, s, v) {
    s /= 100;
    v /= 100;
    var c = v * s;
    var x = c * (1 - Math.abs(h / 60 % 2 - 1));
    var m = v - c;
    var r = 0, g = 0, b = 0;
    if (h >= 0 && h < 60) {
        r = c;
        g = x;
    }
    else if (h >= 60 && h < 120) {
        r = x;
        g = c;
    }
    else if (h >= 120 && h < 180) {
        g = c;
        b = x;
    }
    else if (h >= 180 && h < 240) {
        g = x;
        b = c;
    }
    else if (h >= 240 && h < 300) {
        r = x;
        b = c;
    }
    else if (h >= 300 && h < 360) {
        r = c;
        b = x;
    }
    return {
        r: Math.round((r + m) * 255),
        g: Math.round((g + m) * 255),
        b: Math.round((b + m) * 255)
    };
};
export var getHueColor = function getHueColor(hue) {
    var rgb = hsvToRgb(hue, 100, 100);
    return rgbToHex(rgb.r, rgb.g, rgb.b);
};
